import { APIGet, APIPost, APIPut, APIDelete, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";
import { ITournamentOrganizer } from "redux/reducers/models/tournament";

const apiVersion = "2022-09";
const adminType = "facility-admin";
const tournamentOrganizerUrl = "/" + apiVersion + "/" + adminType + "/tournament/organizer";

interface IGetTournamentOrganizerRes {
  data: ITournamentOrganizer[];
  status: number;
  message: string;
}
interface IPostTournamentOrganizerRes {
  data: ITournamentOrganizer[];
  status: number;
}
interface IPutTournamentOrganizerRes {
  data: ITournamentOrganizer;
  status: number;
  message: string;
}
interface IDeleteTournamentOrganizerRes {
  data: any;
  status: number;
}

type GetOrganizerParams = {
  id?: number;
  tournament_id?: number;
};
export async function GetTournamentOrganizer(
  params: GetOrganizerParams,
  useGlobalLoader: boolean,
  token?: CancelToken,
): Promise<IGetTournamentOrganizerRes> {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/tournament/organizer"), params, useGlobalLoader, token);
}

type PostOrganizerParams = {
  tournament_id: number;
  user_id: number;
};
export async function PostTournamentOrganizer(
  params: PostOrganizerParams,
  useGlobalLoader: boolean,
): Promise<IPostTournamentOrganizerRes> {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/tournament/organizer"), params, useGlobalLoader);
}

type DeleteOrganizerParams = {
  id: number;
};

export async function DeleteTournamentOrganizer(
  params: DeleteOrganizerParams,
  useGlobalLoader: boolean,
): Promise<IDeleteTournamentOrganizerRes> {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/tournament/organizer"), params, useGlobalLoader);
}
